/**
 * Show color labels in filter
 */
var show_color_labels = function () {
    var input_colors = jQuery( ".bapf_stylecolor li" );

    input_colors.each( function () {
        let colors      = jQuery( this ).find( "input" ).attr( "data-name" );
        let color_lable = jQuery( this ).find( "label" );

        color_lable.attr( "title", colors );
    } );
};

jQuery( document ).ready( show_color_labels );


// Modals.
( function ( $ ) {
    /**
     * Opens modal.
     * @param {string} name
     */
    var modal_open = function ( name ) {
        var modal = $( ".im-modal[data-modal='" + name + "']" );

        if ( modal.length === 0 ) {
            return;
        }

        modal.addClass( "active" );
        $( document.body ).addClass( "modal-open" );
    };

    /**
     * Closes modal.
     * @param {string} name
     */
    var modal_close = function ( name ) {
        var modal = $( ".im-modal[data-modal='" + name + "']" );

        if ( modal.length === 0 ) {
            return;
        }

        modal.removeClass( "active" );
        $( document.body ).removeClass( "modal-open" );
    };

    // Open modal when open element clicked.
    $( ".open-modal" ).on( "click", function () {
        var button = $( this );

        if ( ! button.hasClass( "disabled" ) ) {
            modal_open( button.data( "modal" ) );
        }
    } );

    // Close modal when close icon clicked.
    $( ".im-close-modal" ).on( "click", function () {
        var modal_name = $( this ).closest( ".im-modal" ).data( "modal" );
        modal_close( modal_name );
    } );

    // Close modal when backdrop clicked.
    $( ".im-modal" ).on( "click", function ( event ) {
        var target = $( event.target );

        if ( target.hasClass( "im-modal" ) ) {
            modal_close( target.data( "modal" ) );
        }
    } );
} )( jQuery );
